import React from "react";
import { firebase, getTeacherData } from "~/src/api";
import * as ROUTES from "~/src/constants/routes";
import {
  AppWithAuthentication,
  Head,
  Layout,
  Divider,
} from "~/src/components/global";
import { Hero } from "~/src/components/content";
import { ListingPageGeo } from "~/src/components/shared";
import { TeacherGridItem } from "~/src/components/teachers";

function Teachers() {
  return (
    <AppWithAuthentication>
      <Layout>
        <Head
          title="Teachers · Bolstr"
        />
        <Hero
          title="The largest online directory of health and fitness teachers."
          button={{
            label: "Add Your Teacher Profile",
            href: ROUTES.PROFILE_TEACHER,
          }}
          image="https://images.unsplash.com/photo-1575052814074-c05122e0a17a?ixlib=rb-1.2.1&auto=format&fit=crop&w=600&h=360&q=80"
          imageAlt="Teachers"
        />

        <Divider extraLoose />

        <ListingPageGeo
          label="teachers"
          defaultQuery={firebase.db.collection("teachers").orderBy("video", "desc").orderBy("photo", "desc")}
          filteredQuery={firebase.db.collection("teachers")}
          geoQuery={firebase.GeoFirestore.collection("teachers")}
          promiseFunction={(doc) => getTeacherData({ teacher: doc })}
          sortFunction={(a, b) => {
            if (a.pro && !b.pro) return -1;
            if (b.pro && !a.pro) return 1;
            if (a.video && !b.video) return -1;
            if (b.video && !a.video) return 1;
            if (a.photo && !b.photo) return -1;
            if (b.photo && !a.photo) return 1;
            return 0;
          }}
          listItem={(result) => (
            <TeacherGridItem teacher={result} />
          )}
        />
      </Layout>
    </AppWithAuthentication>
  );
}

export default Teachers;
